module.exports = __webpack_public_path__ + "media/images/ui__textCrossLight--dark-17b4aa07017771f33902dac82e6e1174.png";